import AlertIcon from 'images/alert_icon.svg'
import React from 'react'
import { mixinErrorMessageClasses } from 'spa/member/styles/mixin'
import { FormErrorMessageProps } from './types'

export const StyledFormErrorMessage: React.FC<FormErrorMessageProps> = props => {
  return (
    <div className={mixinErrorMessageClasses}>
      <img src={AlertIcon} alt="alert" style={{ paddingTop: '2.5px' }} />
      {props.message}
    </div>
  )
}
